// src/version.js
export const APP_VERSION = "v1.5.2";